export default __webpack_public_path__ + "static/media/loginLogo.e8b1480e.svg";